// Single source of truth for standardized PersonaData titles.
// Used by:
// - components/adresses/data/DatalistOptions.jsx (datalist rendering)
// - components/adresses/data/HouseholdDataTable.jsx (lock TITEL + delete on these rows)
// - pages/adresses/Overview.jsx (derive STRAAT from Straatnaam + Huisnummer)
export const STANDARDIZED_DATA_FIELDS = [
    // Drives the CO2 calculation for per-bewoner interventies (waterbesparende
    // douchekop, douchetimer). It has to be typed in: BAG holds buildings not
    // people, BRP is not accessible to us, and the CBS buurt-average would be
    // an ecological fallacy applied to a single household (ADR-030).
    // Read via src/helpers/adressHelpers/readResidentCount.js.
    'Aantal bewoners',
    'Bijzonderheden',
    'Coach',
    'Coachverslag',
    'E-mail',
    'Flexibel inplannen',
    'Over ons gehoord via',
    'Huisnummer',
    'Naam',
    'Notitie',
    'Postcode',
    'Straatnaam',
    'Taal',
    'Telefoonnummer',
    'Type woning',
    'Voorkeursdagen',
    'Woningbouwcooperatie',
    'Woonplaats',
];
